import React from 'react';
import i18n from 'i18next';

import {
  Flex,
  Text,
} from 'web-styled';

import {
  Tooltip,
} from 'web-components';

import * as S from '../styled';

const tooltipTexts = {
  activity: 'This area displays recent activity involving you and your clients',
};

const getActivityTo = (activity: any): string => {
  switch (activity.key) {
    case 'personal_program.create':
      return `/personal_programs/${activity.trackable_id}`;
    case 'personal_workout.create':
      return `/personal_workouts/${activity.trackable_id}`;
    case 'user.invitation_accepted':
      return `/users/${activity.trackable_id}/programs`;
    case 'exercise_result.create':
      return `/events/${activity.trackable_id}`;
    case 'video.create':
      return `/users/${activity.owner_id}/videos`;
    default:
      return `/workout_events/${activity.trackable_id}`;
  }
};

type Props = {
  notifications: any[],
  isPro: boolean,
};

const Activity = ({ notifications, isPro }: Props) => (
  <Flex
    column
    width="100%"
  >
    <Flex
      width="100%"
      align="center"
      justify="center"
    >
      {
        isPro
          ? (
            <Tooltip
              body={tooltipTexts.activity}
              preferPlace="above"
              width="200px"
            >
              <Text color="#757575">
                Recent Activity:
              </Text>
            </Tooltip>
          )
          : (
            <Text color="#757575">
              Recent Activity:
            </Text>
          )
      }
    </Flex>
    <Flex column width="100%">
      {notifications.map(item => (
        <Flex
          key={item.id}
          width="100%"
          padding="10px 0"
          borderBottom="1px solid #ededed"
        >
          <Flex align="center">
            <Flex flex="0 0 36px" align="center">
              <S.ActivityIcon type={item.key} />
            </Flex>
            <S.ActivityLink to={getActivityTo(item)}>
              {`${item.owner_full_name} ${i18n.t(`event.${item.key}`)}`}
            </S.ActivityLink>
          </Flex>
        </Flex>
      ))}
    </Flex>
  </Flex>
);

export default Activity;
